import { render, staticRenderFns } from "./NoticeBand.vue?vue&type=template&id=c3864632&scoped=true&"
import script from "./NoticeBand.vue?vue&type=script&lang=js&"
export * from "./NoticeBand.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBand.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NoticeBand.vue?vue&type=style&index=1&id=c3864632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3864632",
  null
  
)

export default component.exports